/** Клиент: режим сравнения «Телефон + НД» (недозвон). */

export function normalizeVprCrossMatchMode(mode) {
  if (mode === 'phone_fio') return 'phone_fio';
  if (mode === 'phone_nd') return 'phone_nd';
  if (mode === 'leading_phone_fio') return 'leading_phone_fio';
  return 'phone';
}

export function detectManualNdCol(headers) {
  if (!Array.isArray(headers)) return -1;
  const normalized = headers.map((h) => String(h ?? '').trim().toLowerCase().replace(/\s+/g, ' '));
  const ndNames = [
    'нд', 'недозвон', 'недозв', 'статус', 'комментар', 'коментар', 'примечан',
    'примітк', 'результат', 'итог', 'позначк', 'відмітк', 'отметк', 'звонок', 'прозвон',
  ];
  for (const name of ndNames) {
    const n = name.toLowerCase();
    const i = normalized.findIndex((h) => h === n || (h && h.includes(n)));
    if (i >= 0) return i;
  }
  return -1;
}
